import { fetchHelper } from '../helpers/fetch';
import { getUnixTimestamp } from '../utils/datetime.js';

import getLivestreamUrl from './staylive/getStayLiveUrl';

import type { UnixTimestamp } from '@vgtv/api-client';

export type StayliveStream = {
  id: number;
  name: string;
  thumbnail: string;
  start: number | string; // not sure which date-like type is this
  end: number | string; // not sure which date-like type is this
};

async function fetchStreams(url: string) {
  try {
    const response = await fetchHelper<{ message: StayliveStream[] }>(
      `${url}?limit=30`
    );

    return response.message || [];
  } catch {
    return [];
  }
}

function isStreamUpcoming(serverTime: UnixTimestamp, stream: StayliveStream) {
  const unixStartTime = new Date(stream.start).getTime() / 1000;

  return unixStartTime > serverTime;
}

function isStreamLive(serverTime: UnixTimestamp, stream: StayliveStream) {
  const unixStartTime = getUnixTimestamp(stream.start);
  const unixEndTime = getUnixTimestamp(stream.end);

  return serverTime >= unixStartTime && serverTime < unixEndTime;
}

function getChannelUrl(channelId: number) {
  if (channelId === 2677 || channelId === 3333) {
    return 'https://www.sportbladetplay.se/fotboll/damallsvenskan';
  }

  if (channelId === 2603 || channelId === 3210) {
    return 'https://www.sportbladetplay.se/bandy';
  }
}

export {
  fetchStreams,
  isStreamUpcoming,
  isStreamLive,
  getChannelUrl,
  getLivestreamUrl,
};
